import React from 'react';

import icon from 'assets/images/softwares/WellInsight1.png';

const Icon = ({ width }) => <img src={icon} alt="Well Insight" width={width || '25'} />;

export default Icon;
